var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#219646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#259d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.619048 0h8.380952v11.428571h-8.380952z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.333333v11.428571h-5.333333z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.571429 0h6.857143v11.428571h-6.857143z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.19510072 3.05001834.32153862-1.15753903c.05655853-.2036107.27911959-.36866979.48336066-.36866979.21039421 0 .42803665.16950335.48336069.36866979l.32153859 1.15753903c-.01411261-.00158516-.02845852-.00239929-.04299452-.00239929-.21039421 0-.38095238.17055819-.38095238.38095238s.17055817.38095238.38095238.38095238c.08733958 0 .16781425-.02939186.23207261-.07882407l.23633768.85081566c-.02808244-.00659702-.05736267-.01008683-.08745791-.01008683-.21039421 0-.38095238.1705582-.38095238.38095238 0 .21039419.17055817.38095238.38095238.38095238.10358156 0 .19750766-.04133994.26617936-.1084209l.24845592.89444155c-.04159573-.01559028-.08664366-.02411588-.1336829-.02411588-.21039421 0-.38095238.17055819-.38095238.38095238 0 .21039418.17055817.38095238.38095238.38095238.12096336 0 .22875886-.05637843.29854317-.14429196l.46336151 1.66810148h-1.90476182v1.52380952h-.76190477v-1.52380952h-1.9047619l.46336154-1.66810155c.06978428.08791357.17757981.14429203.29854323.14429203.21039418 0 .38095238-.1705582.38095238-.38095238 0-.21039419-.1705582-.38095238-.38095238-.38095238-.04703924 0-.09208722.00852561-.133683.02411591l.24845601-.89444162c.06867168.06708097.16259779.10842094.26617937.10842094.21039418 0 .38095238-.17055819.38095238-.38095238 0-.21039418-.1705582-.38095238-.38095238-.38095238-.03009529 0-.05937548.00348981-.08745799.01008684l.23633769-.85081569c.06425839.04943223.14473312.07882409.23207268.07882409.21039418 0 .38095238-.17055819.38095238-.38095238s-.1705582-.38095238-.38095238-.38095238c-.01453602 0-.02888191.00081413-.04299452.00239929z",
    fill: "url(#d)",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNf);
export default __webpack_public_path__ + "static/media/NF.f4779a332bbf466bc046fd111865905f.svg";
export { ForwardRef as ReactComponent };